import { render, staticRenderFns } from "./span.vue?vue&type=template&id=a36a0cb6"
import script from "./span.vue?vue&type=script&lang=js"
export * from "./span.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports